import { EarningMechanismConfigurationInput } from '@occc/graphql';
import { DirtyFieldsType, Operation, AwardType } from '@occc-app/offerHelpers/types';
import { isFieldDirty } from '@occc-app/offerHelpers/utils';
import { makeDeleteOperation } from '@occc-app/offerHelpers/operations/makeDeleteOperation';
import { makeEarningMechanismCreateOperation } from '@occc-app/offerHelpers/operations/earningMechanism';
import { earningMechanismInputCreator } from '@occc-app/offerHelpers/earningMechanismInputCreator';
import { getAwardInput } from '@occc-app/offerHelpers/utils/getAwardInput';

import { PunchcardConfigureFormValues } from '../../../types';

type EarningMechanismCreateInput = Pick<
  EarningMechanismConfigurationInput,
  'varietyPurchaseOverTime'
>;

type GetEarningMechanismCreateInput = (
  values: PunchcardConfigureFormValues,
) => EarningMechanismCreateInput;

const getEarningMechanismCreateInput: GetEarningMechanismCreateInput = (values) => {
  const awardInput = getAwardInput({
    awardType: values.awardType,
    awardPoints: values.awardType === AwardType.AwardPoints ? values.awardPoints : undefined,
    awardVouchers: values.awardType === AwardType.AwardVouchers ? values.awardVouchers : undefined,
  });

  return earningMechanismInputCreator.createVarietyPurchaseOverTime(
    values.punchcardChallenge.products,
    awardInput,
    true,
    values.punchcardChallenge.stayVisibleWhileInProgress?.isEnabled,
  );
};

export const getEarningMechanismOperations = (
  offerId: string,
  values: PunchcardConfigureFormValues,
  dirtyFields: DirtyFieldsType,
): Operation[] => {
  const operations: Operation[] = [];

  if (
    !isFieldDirty<PunchcardConfigureFormValues>(dirtyFields, 'punchcardChallenge') &&
    !isFieldDirty<PunchcardConfigureFormValues>(dirtyFields, 'awardType') &&
    !isFieldDirty<PunchcardConfigureFormValues>(dirtyFields, 'awardPoints') &&
    !isFieldDirty<PunchcardConfigureFormValues>(dirtyFields, 'awardVouchers')
  ) {
    return operations;
  }

  if (values.earningMechanism.id) {
    operations.push(makeDeleteOperation('earningMechanismDelete', values.earningMechanism.id));
  }

  const configuration = getEarningMechanismCreateInput(values);
  operations.push(makeEarningMechanismCreateOperation(offerId, configuration));

  return operations;
};
